export default __webpack_public_path__ + "static/media/cross-icon1.15792af1.svg";